import { useEffect, type ReactNode } from 'react';
import { App } from 'antd';
import { initializeNotifications } from '../lib/notification';

interface NotificationProviderProps {
  children: ReactNode;
}

/**
 * NotificationProvider
 *
 * This component initializes the global notification system.
 * It must be rendered inside Ant Design's App component to access
 * the message and notification APIs.
 *
 * Once initialized, you can use toast and notify from anywhere:
 * import { toast, notify } from '../lib/notification';
 * toast.success('Done!');
 * notify.error({ message: 'Error', description: 'Details...' });
 */
export function NotificationProvider({ children }: NotificationProviderProps) {
  const { message, notification } = App.useApp();

  useEffect(() => {
    // Initialize the global notification service
    initializeNotifications(message, notification);
  }, [message, notification]);

  return <>{children}</>;
}
